
import { Component, Vue, Prop } from "vue-property-decorator"

@Component({})
export default class ViewFolderItem extends Vue {
	@Prop({ type: String, default: null })
	activeViewId!: string | null;

	@Prop({ type: String, default: "" })
	viewId!: string;

	@Prop({ type: String, default: "" })
	title!: string;

	@Prop({ type: Number, default: null })
	caseCount!: number | null;

	public viewSelected (viewId: string) {
		this.$emit("viewSelected", viewId)
	}
}
